import { RequestService } from '../request';

import { IUserFirstSteps } from './user-first-steps.contract';

export class UserFirstStepsService extends RequestService {
  constructor(apiUrl: string) {
    super(apiUrl);
  }

  public getMyFirstSteps() {
    return this.fetcher<IUserFirstSteps>(`/user-first-steps/me`);
  }
} 